import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedDataService } from './services/shared-data.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(private router: Router, private sharedData: SharedDataService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isActivated = false;
    const currentUser = this.sharedData.getCurrentUserToken();

    if (currentUser && currentUser.token) {
      // logged in so return true
      isActivated = true;
      this.sharedData.setUserDataFromLS();
      this.sharedData.updateHolidays();
    } else {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      isActivated = false;
    }
    this.sharedData.setLoginState(isActivated);
    return isActivated;
  }
}
